<template>
  <div class="kvass-button-group">
    <DropdownComponent
      class="kvass-button-group__secondary"
      :close-on-click="false"
      :dropdown-wrapper="usePortal ? Portal : 'div'"
    >
      <template #default>
        <ButtonComponent :icon="secondaryIcon" />
      </template>
      <template #dropdown="{ close, visible }">
        <slot name="secondary" :close="close" :visible="visible"></slot>
      </template>
    </DropdownComponent>
    <slot />
  </div>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'
import { Portal } from '@linusborg/vue-simple-portal'
export default {
  props: {
    usePortal: {
      type: Boolean,
      default: true,
    },
    secondaryIcon: {
      type: String,
      default: 'fa-pro-light:angle-down',
    },
  },
  data() {
    return {
      Portal,
    }
  },
  components: {
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.kvass-button-group {
  display: flex;

  & > * {
    order: 1;

    &:nth-child(n + 3) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: none;
    }
  }

  .elder-dropdown:not(.elder-dropdown--hidden) {
    & ~ * {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .elder-dropdown--hidden {
    & ~ *:not(:last-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  &__secondary {
    order: 100;

    &:nth-last-child(n + 2) .elder-dropdown__trigger button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: none;
    }
  }
}
</style>
